import React from 'react';
import PropTypes from 'prop-types';
import PlacesAutocomplete from 'react-places-autocomplete';
import Box from '@material-ui/core/Box';

import AddressInput from 'bento-ordering/base/components/AddressInput';
import Suggestions from 'bento-ordering/locations/components/Suggestions';
import { geocodePlaceId } from 'bento-ordering/base/utils/addressHelpers';
import Error from 'bento-ordering/base/components/Error';

import {
  ZERO_RESULTS,
  NOT_DELIVERABLE,
  NOT_DELIVERABLE_NO_PICKUP,
  EMPTY_STRING
} from 'bento-ordering/base/constants/errorTypes';
import { WHITE } from 'bento-ordering/base/constants/colors';
class AddressAutoCompleteInput extends React.Component {
  static propTypes = {
    handleSelect: PropTypes.func.isRequired,
    initialValue: PropTypes.string,
    label: PropTypes.string,
    includeAdornment: PropTypes.bool,
    isOnDarkBackground: PropTypes.bool,
    // local state in this component is initialized with error: ''
    error: PropTypes.oneOf([
      ZERO_RESULTS,
      NOT_DELIVERABLE,
      NOT_DELIVERABLE_NO_PICKUP,
      EMPTY_STRING
    ])
  };
  static defaultProps = {
    label: 'Your address',
    initialValue: '',
    includeAdornment: false,
    isOnDarkBackground: false,
    error: ''
  };

  constructor(props) {
    super();

    this.state = {
      address: props.initialValue || '',
      error: ''
    };
  }

  handleAddressChange = address => {
    this.setState({ address });
  };

  /**
   * Filter the location list by distance once the user selects an address
   */
  handleAddressSelect = async (address, placeId) => {
    /**
     * we add this placeId check bc if the user types an address and hits enter without selecting
     * a google verified address, there is no placeId which throws an invalid request error from google
     */
    if (placeId) {
      this.setState({ address });

      const { geocodedSuggestion, latLng } = await geocodePlaceId(placeId);

      this.props.handleSelect(
        geocodedSuggestion.address_components,
        latLng,
        placeId
      );
    }
  };

  renderSuggestions(loading, suggestions, getSuggestionItemProps) {
    return (
      <Suggestions
        loading={loading}
        suggestions={suggestions}
        getSuggestionItemProps={getSuggestionItemProps}
      />
    );
  }

  renderAutoCompleteInput = ({
    getInputProps,
    getSuggestionItemProps,
    loading,
    suggestions
  }) => {
    const { value, ...inputProps } = getInputProps();
    const error = this.state.error || this.props.error;
    const shouldDisplayError = !!error && !suggestions.length;
    return (
      <div>
        <AddressInput
          {...inputProps}
          value={value}
          label={this.props.label}
          error={error}
          includeAdornment={this.props.includeAdornment}
          isOnDarkBackground={this.props.isOnDarkBackground}
        />

        {shouldDisplayError && (
          <Box mt={1}>
            <Error
              status={error}
              color={this.props.isOnDarkBackground ? WHITE : ''}
            />
          </Box>
        )}

        {this.renderSuggestions(loading, suggestions, getSuggestionItemProps)}
      </div>
    );
  };

  render() {
    return (
      <PlacesAutocomplete
        value={this.state.address}
        onChange={address => {
          this.handleAddressChange(address);
          this.setState({
            error: false
          });
        }}
        onSelect={this.handleAddressSelect}
        shouldFetchSuggestions={this.state.address.length > 3}
        onError={(status, clearSuggestions) => {
          this.setState({ error: status }, () => {
            clearSuggestions();
          });
        }}
      >
        {this.renderAutoCompleteInput}
      </PlacesAutocomplete>
    );
  }
}

export default AddressAutoCompleteInput;
